<div class="d-flex justify-content-end mb-3">
  <select class="form-select me-2" style="height: 40px; width: 80px" (change)="changePageSize($event)" *ngIf="userTable">
    <option *ngFor="let option of pageSizeOptions" [value]="option" [selected]="option === pageSize">
      {{ option }}
    </option>
  </select>
  <pagination
    class="mb-2"
    [totalItems]="total"
    [itemsPerPage]="pageSize"
    [maxSize]="5"
    [boundaryLinks]="true"
    [directionLinks]="true"
    [rotate]="false"
    [previousText]="'‹'"
    [nextText]="'›'"
    [firstText]="'«'"
    [lastText]="'»'"
    [(ngModel)]="currentPage"
    (pageChanged)="onPageChanged($event)"
  ></pagination>
</div>
